export const selectUser = (state) => state.authentication.user;
export const selectUserLoading = (state) => state.authentication.loading;
export const selectUserError = (state) => state.authentication.error;

export const selectUserRoles = (state) => state.authentication.user.user.userRoles;
export const selectUserSuperAdmin = (state) => state.authentication.user.user.isSuperAdmin;
export const selectLoadingUserRoles = (state) => state.authentication.loadingUserData